import M from 'backbone.marionette'
import { IndexeurAutocompleteView } from '../utils/autocomplete/indexeurautocomplete';
import Backbone from 'backbone';

export const FID = M.View.extend({
    template: _.template('<input type="hidden" style="display: none" /><div />'),
    regions: {
        'input':'>input',
        'div': '>div',
    },
    modelEvents: {
        'change':'onModelChange'
    },
    ui: {
        'input':'>input',
    },
    initialize: function(){
        this.model = new Backbone.Model({
            id: this.getOption('value'),
        }) 
    },
    onModelChange: function(){
        this.ui.input.val(this.model.get('id'));
    },
    onRender: function(){
        this.ui.input.attr('name', this.getOption('inputName'));
        this.ui.input.val(this.model.get('id'));
        this.showChildView('div', new IndexeurAutocompleteView({
            attributes: {
                placeholder: 'Rechercher ...'
            },
            indexType: this.getOption('model'),
            model: this.model,
            attribute: 'id',
            serviceUrl: 'autocomplete/search/' + this.getOption('model'),
            renderItem: (item, currentValue) => {
                const element = document.createElement("div");
                element.innerHTML = item.label;
                return element;
            },
            onSelect: (item)=> {
                this.model.set('id', item);
            }
        }))
    }
})